import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'WheelsStepwiseIndicator',
  props: {
    steps: null,
    currentStepIdx: { default: 0 },
    clickable: { type: Boolean, default: false },
    showLabels: { type: Boolean, default: true }
  },
  emits: ["step-click"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'step-click', step: number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { steps: Array<{label: string}>, currentStepIdx: number, clickable: boolean, showLabels: boolean };



const steps = ref(props.steps)



const handleStepClick = (step: number) => {
  emit('step-click', step)
}


return { __sfc: true,props, steps, emit, handleStepClick }
}

})